import { Grid, Typography, Box } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import React, { useState } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from 'react-router-dom';
import CustomTabs from 'src/components/tabs/custom-tabs';
import {
  IQuickStartObject,
  IQuickStartCardObject
} from '../../../../types/landing-api-response.model';

export default function UserProfile({
  profileData
}: {
  profileData: IQuickStartObject[];
}) {
  const [selectedSubTab, setSelectedSubTab] = useState(profileData[0].name);

  const [cardsData, setCardsData] = useState(
    () => profileData.filter((ele) => ele.name === profileData[0].name)[0]
  );

  //   preparing sub tab data
  const subTabData = profileData
    // .sort((a, b) => (a.order - b.order ))
    .map((ele) => ({
      label: ele.alias,
      value: ele.name,
      icon: ele.icon
    }));

  //   handler for toggling tabs
  const handleToggleChange = (event, newValue) => {
    setSelectedSubTab(newValue);
    // updating the cards data as per active tab
    const newActiveTabCardsData = profileData.filter(
      (ele) => ele.name === newValue
    )[0];
    setCardsData(newActiveTabCardsData);
  };

  return (
    <div className='user-profile-content-div-parent'>
      <div style={{ margin: '10px 0px' }}>
        <Typography className='quick-start-desc'>
          Reports are grouped based on the user profiles, and sorted by the key
          business questions that the users are looking to answer.
        </Typography>
      </div>

      <div className='user-profile-content-div'>
        <div className='tabs-container-div'>
          {CustomTabs({
            selectedTab: selectedSubTab,
            tabData: subTabData,
            handleToggleChange
          })}
        </div>
        <div className='cards-container'>
          <Grid container spacing={1}>
            {cardsData.data.map((ele: IQuickStartCardObject) => (
              <Grid item xs={6}>
                <div className='card-content1'>
                  <Typography className='quick-start-desc'>
                    {ele.question}
                  </Typography>
                  <Link to={ele.page_route_url as string}>
                    <div className='page-details'>
                      <Typography className='page-details-text'>
                        {ele.page_prefix} {ele.page_alias}
                      </Typography>
                      <div className='page-details-icon'>
                        <KeyboardArrowRightIcon
                          sx={{ color: '#0000a0', fontSize: '18px' }}
                        />
                      </div>
                    </div>
                  </Link>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </div>
  );
}
